<template>
  <div>
      <p v-if="geoipLocation">
        {{ gettext('Based on the information delivered by your web browser you appear to be located in:') }}
      </p>
      <div class="form-group flex">
          
        <div class="input-group input-group-select">
            <div class="select-wrapper" :class="{error: $v.province.$error || (!$v.province.$dirty && $v.city.$dirty), valid: $v.province.$dirty && !$v.province.$invalid}">
              <label class="visually-hidden" for="signup-province">{{ pgettext('Select province label', 'Select province or territory') }}</label>
              <select v-model="province" name="signup-province" id="signup-province"
                @input="$v.province.$touch">
                <option value="">{{ pgettext('Select province', 'Province or territory') }}</option>
                <option v-for="province in provinces"
                        :key="province.abbreviation"
                        :value="province.abbreviation">
                  {{ province.name }}
                </option>
              </select>
            </div>
            <span class="form-error" v-if="$v.province.$dirty && (!$v.province.required && !$v.city.$error)">{{ gettext('Please select a province or territory.') }}</span>
            <span class="form-error" v-if="!$v.province.$dirty && $v.city.$dirty">{{ gettext('Please select a province or territory first.') }}</span>
            <span class="form-error" v-if="($v.province.$dirty && $v.city.$dirty) && (!$v.province.required && !$v.city.required)">{{ gettext('Please select a province or territory, and city.') }}</span>
        </div>
        
        <div class="input-group input-group-select right-margin-0">
            <div class="select-wrapper" :class="{error: $v.city.$error, valid: $v.city.$dirty && !$v.city.$invalid}">
              <label class="visually-hidden" for="signup-city">{{ pgettext('Select city label', 'Select city') }}</label>
              <select v-model="city" name="signup-city" id="signup-city"
                @input="$v.city.$touch">
                <option value="">{{ pgettext('Select city', 'City') }}</option>
                <option v-for="city in cities"
                        :key="city"
                        :value="city">
                  {{ city }}
                </option>
              </select>
            </div>
            <span class="form-error" v-if="($v.province.$dirty && $v.city.$dirty) && (!$v.city.required && !$v.province.$error)">{{ gettext('Please select a city.') }}</span>
        </div>
        
      </div>
      
      <p v-if="geoipLocation">
        {{ gettext('If the above information is not accurate, please click on the dropdown and select the correct response.') }}
      </p>
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'CityPicker',
    props: {
      initialProvince: {
        type: String,
        default: () => ''
      },
      initialCity: {
        type: String,
        default: () => ''
      },
      provinces: {
        type: Array,
        default: () => []
      },
      citiesUrl: {
        type: String,
        required: true
      },
    },

    data: function() {
      return {
        province: this.initialProvince,
        city: this.initialCity,
        cities: [this.initialCity],
        geoipLocation: false
      }
    },

    watch: {
      province: function(newProvince) {
        this.city = ''
        this.loadCities(newProvince)
      }
    },

    beforeMount: function() {
      if (this.initialProvince) {
        this.loadCities(this.initialProvince)
      }
    },

    methods: {
      loadCities: function(province) {
        return axios.get(this.citiesUrl + '/' + province)
          .then((resp) => { this.cities = resp.data.cities })
          // in the unlikely event someone deselects the province...
          .catch((error) => { this.cities = '' })
      }
    },
    
    validations: {
      province: {
        required
      },
      city: {
        required
      }
    }
  }
</script>



// WEBPACK FOOTER //
// js/CityPicker.vue